document.querySelectorAll('.js--toggle-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
        const toggleBox = btn.closest('.js--toggle-box');

        if (toggleBox) {
            const isOpen = toggleBox.classList.toggle('-open');
            btn.textContent = isOpen ? '閉じる' : '詳しく見る';
        }
    });
});